import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const PeopleTalkingIllustration = ({
  width = 250,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 237">
      <defs>
        <path id="ddxbcrgxna" d="M0.204 0L78.487 0 78.487 156.566 0.204 156.566z" />
        <path id="i4fgnh7m6c" d="M0.775 0.982L95 0.982 95 58 0.775 58z" />
        <path id="usgyvxegge" d="M0 0.458L65.321 0.458 65.321 39.985 0 39.985z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#93C8E1"
          d="M164.487 78.283C164.487 35.048 129.438 0 86.204 0 42.969 0 7.921 35.048 7.921 78.283c0 16.248 4.952 31.34 13.426 43.848 3.317-1.972 7.185-3.109 11.316-3.109 12.24 0 22.198 9.958 22.198 22.2 0 2.858-.549 5.59-1.538 8.102 10 4.636 21.133 7.241 32.881 7.241 15.633 0 30.195-4.584 42.418-12.48l35.865 12.48-12.481-35.864c7.896-12.223 12.481-26.785 12.481-42.418"
        />
        <path
          fill="#F4F4F4"
          d="M111.845 51.565c6.134 0 11.106 4.972 11.106 11.106v27.922c0 6.134-4.972 11.107-11.106 11.107H89.456c-1.416 0-2.778.54-3.808 1.511l-16.76 15.786v-14.52c0-1.534-1.244-2.777-2.778-2.777h-5.89c-4.787 0-8.667-3.88-8.667-8.667V62.671c0-6.134 4.973-11.106 11.107-11.106h49.185zM71.386 73.381c2.191 0 3.967 1.776 3.967 3.967 0 2.19-1.776 3.966-3.967 3.966-2.19 0-3.967-1.776-3.967-3.966 0-2.19 1.776-3.967 3.967-3.967zm16.065 0c2.19 0 3.966 1.776 3.966 3.967 0 2.19-1.776 3.966-3.966 3.966-2.19 0-3.967-1.776-3.967-3.966 0-2.19 1.776-3.967 3.967-3.967zm15.668 0c2.19 0 3.966 1.776 3.966 3.967 0 2.19-1.776 3.966-3.966 3.966-2.19 0-3.967-1.776-3.967-3.966 0-2.19 1.776-3.967 3.967-3.967z"
        />
        <g transform="translate(86)">
          <path
            fill="#000"
            d="M.204 156.566c15.634 0 30.196-4.585 42.418-12.48l35.865 12.48-12.48-35.865c7.895-12.222 12.48-26.784 12.48-42.418C78.487 35.049 43.439 0 .204 0v156.566z"
            opacity=".1"
          />
        </g>
        <path
          fill="#004C8F"
          d="M202.89 173.577c14.187 0 25.676-11.49 25.676-25.671s-11.49-25.676-25.675-25.676c-14.181 0-25.682 11.495-25.682 25.676 0 14.18 11.5 25.67 25.682 25.67"
        />
        <g transform="translate(155 179)">
          <path
            fill="#004C8F"
            d="M60.55.982L47.884 13.648 35.225.982C15.358 6.52.775 24.7.775 46.32.775 46.32 5.977 58 47.887 58 89.798 58 95 46.32 95 46.32 95 24.7 80.412 6.52 60.55.981"
          />
        </g>
        <path
          fill="#91A1A3"
          d="M32.663 159.018c9.834 0 17.799-7.965 17.799-17.796s-7.965-17.8-17.8-17.8c-9.83 0-17.803 7.969-17.803 17.8 0 9.83 7.973 17.796 17.804 17.796"
        />
        <g transform="translate(0 163)">
          <path
            fill="#91A1A3"
            d="M41.439.458l-8.781 8.78-8.776-8.78C10.11 4.296 0 16.9 0 31.887c0 0 3.607 8.098 32.66 8.098 29.055 0 32.66-8.098 32.66-8.098C65.32 16.9 55.209 4.296 41.44.458"
          />
        </g>
      </g>
    </svg>
  </DefaultIconWrapper>
);
